export default "__VITE_ASSET__003fe03e__"